import { render, staticRenderFns } from "./curvaProdutos.vue?vue&type=template&id=502d2832"
import script from "./curvaProdutos.ts?vue&type=script&lang=js&external"
export * from "./curvaProdutos.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('502d2832')) {
      api.createRecord('502d2832', component.options)
    } else {
      api.reload('502d2832', component.options)
    }
    module.hot.accept("./curvaProdutos.vue?vue&type=template&id=502d2832", function () {
      api.rerender('502d2832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/curvaABC/curvaProdutos.vue"
export default component.exports